export const onLoadHeader = payload => ({
    type: 'ON_LOAD_HEADER_SUMMARY',
    payload,
})
export const onLoadPrinter = payload => ({
    type: 'ON_LOAD_PRINTER',
    payload,
})
export const getHeaderSummary = () => ({
    type: 'ON_GET_HEADER_SUMMARY',
})
export const getHeaderSummarySuccess = payload => ({
    type: 'GET_HEADER_SUMMARY_SUCCESS',
    payload,
})
export const fromSummary = (payload) => ({
    type: 'FROM_SUMMARY_HEADER',
    payload
})
export const resetHeaderSumary = (payload) => ({
    type: 'RESET_SUMMARY_HEADER',
})

export const updateSummaryHeader = (payload) => ({
    type: 'UPDATE_SUMMARY_HEADER',
    payload
})



// WEBPACK FOOTER //
// ./src/actions/headerAction.js